import {get} from './http-methods'

export const API = {
  reset: () => get('/game/reset-game/'),
}
